export enum PresenterAccountEvents {

  FormModelDidUpdate = 'PresenterAccount.FormModelDidUpdate',
}